define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "polished", "react-focus-on", "shortid", "react-dom", "../../themes", "./ModalTitle", "./ModalBody", "./ModalFooter"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _taggedTemplateLiteralLoose2, _react, _styledComponents, _polished, _reactFocusOn, _shortid, _reactDom, _themes, _ModalTitle, _ModalBody, _ModalFooter) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ModalFromPortal = _exports.Modal = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _shortid = _interopRequireDefault(_shortid);
  _ModalTitle = _interopRequireDefault(_ModalTitle);
  _ModalBody = _interopRequireDefault(_ModalBody);
  _ModalFooter = _interopRequireDefault(_ModalFooter);
  var _excluded = ["showModal", "buttons", "title", "setShowModal", "labelId", "isTitleVisuallyHidden", "size"];

  var _templateObject;

  var ModalBackdrop = _styledComponents.default.div.withConfig({
    displayName: "Modal__ModalBackdrop",
    componentId: "sc-1ps5poc-0"
  })(["", ";background-color:", ";opacity:1;z-index:1;"], _themes.spread, function (_ref) {
    var theme = _ref.theme;
    return (0, _polished.rgba)(theme.colors.dark, 0.45);
  });

  var ModalWrapper = _styledComponents.default.div.withConfig({
    displayName: "Modal__ModalWrapper",
    componentId: "sc-1ps5poc-1"
  })(["", ";z-index:3;"], _themes.spread);

  var modalContentSize = {
    md: '663px',
    lg: '841px',
    sm: '468px'
  };

  var ModalContent = _styledComponents.default.div.withConfig({
    displayName: "Modal__ModalContent",
    componentId: "sc-1ps5poc-2"
  })(["", ";background-color:", ";border:solid 1px ", ";box-shadow:0 1px 2px 0 rgba(0,0,0,0.3);padding:24px;position:absolute;z-index:2;", ""], _themes.spread, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.white;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.gray;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    bottom: auto;\n    height: auto;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: ", ";    \n  "])), function (_ref4) {
    var size = _ref4.size;
    return modalContentSize[size];
  }));

  var ButtonCloseModal = _styledComponents.default.button.withConfig({
    displayName: "Modal__ButtonCloseModal",
    componentId: "sc-1ps5poc-3"
  })(["", ";border:solid 1px transparent;height:24px;line-height:0;outline:0;position:absolute;right:24px;top:32px;transform-origin:50% 50%;transition:transform 0.2s ", ";width:24px;border:1px solid transparent;box-icon{fill:currentColor;height:100%;transition:fill 0.2s ", ";width:100%;}&:focus,&:hover{color:", ";transform:scale(1.1);}&:focus{", ";}"], _themes.resetButton, function (_ref5) {
    var theme = _ref5.theme;
    return theme.easing.ease;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.easing.ease;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.red;
  }, _themes.focusBoxShadow);

  var Modal = function Modal(_ref8) {
    var showModal = _ref8.showModal,
        buttons = _ref8.buttons,
        title = _ref8.title,
        setShowModal = _ref8.setShowModal,
        labelId = _ref8.labelId,
        isTitleVisuallyHidden = _ref8.isTitleVisuallyHidden,
        size = _ref8.size,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref8, _excluded);

    var handleClose = function handleClose() {
      return setShowModal(false);
    };

    var backDrop = (0, _react.useRef)(null);
    return showModal && /*#__PURE__*/_react.default.createElement(ModalWrapper, null, /*#__PURE__*/_react.default.createElement(ModalBackdrop, {
      onClick: handleClose,
      ref: backDrop
    }), /*#__PURE__*/_react.default.createElement(_reactFocusOn.FocusOn, {
      onEscapeKey: handleClose,
      shards: [backDrop]
    }, /*#__PURE__*/_react.default.createElement(ModalContent, {
      "aria-modal": "true",
      "aria-labelledby": labelId,
      "data-testid": "modal",
      role: "dialog",
      size: size
    }, /*#__PURE__*/_react.default.createElement(ButtonCloseModal, {
      onClick: handleClose
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "x"
    })), /*#__PURE__*/_react.default.createElement(_ModalTitle.default, {
      title: title,
      labelId: labelId,
      isTitleVisuallyHidden: isTitleVisuallyHidden
    }), /*#__PURE__*/_react.default.createElement(_ModalBody.default, rest), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
      buttons: buttons
    }))));
  };

  _exports.Modal = Modal;

  var ModalFromPortal = function ModalFromPortal(_ref9) {
    var props = (0, _extends2.default)({}, _ref9);
    var modalContainer = document.getElementById('modal-root');
    (0, _react.useEffect)(function () {
      // eslint-disable-next-line
      !modalContainer && // eslint-disable-next-line no-console
      console.log('%c 🚨 Please, create a <div> with "id" equal "modal-root", where you need to append the <ModalFromPortal />.', "background: " + _themes.defaultTheme.colors.dark + "; color: " + _themes.defaultTheme.colors.primary + "; padding: 16px");
    }, []);
    return modalContainer ? /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(Modal, props), modalContainer) : null;
  };

  _exports.ModalFromPortal = ModalFromPortal;
  Modal.defaultProps = {
    labelId: _shortid.default.generate(),
    isTitleVisuallyHidden: false,
    size: 'md'
  };
});